import angular from 'angular';

import CaseModel from '../../models/case';
import ContributorModel from '../../models/contributor';
import UserModel from '../../models/user';

class ContributorsCtrl {
  constructor(Contributor, CurrentCase, $location, CurrentUser, $window,
    $timeout, $routeParams) {

    this.user = CurrentUser.data;
    this.routeParams = $routeParams;

    this.location = $location;
    this.window = $window;

    this.model = Contributor;

    // The contributors list is set by the current cases contributors
    this.case = CurrentCase;
    CurrentCase.subscribe(() => {
      this.contributorsList = CurrentCase.data.contributors;
    })

    this.timeout = $timeout;

    this.addButtonStates = {
      false: 'Add',
      true: 'Adding... <i class="font-icon-sm icon-spinner icon-spin">'
    };

    this.initialize();
  }

  initialize() {
    this.contributor = new this.model();
  }
  focus(query){
    this.timeout(() => {
      document.querySelector('.modal-container').querySelector(query).focus()
    })
  }

  cancelNewContributor() {
    // unlock email field and focus it (since adding new locks it)
    this.initialize();
    this.focus('[name="email"]')
  }

  addContributor() {
    // existing users added by email
    // if user is new, email is locked to prevent trying to add existing

    this.contributor.api.add().then(data => {

      this.initialize();
      this.case.setProp('contributors', data)

    }, response => {
      if (response.status === 404) {
        this.focus('[name="firstName"]')
      }
    });
  }

  removeContributor(contributor) {
    if (contributor.id === this.user.id && !this.window.confirm(
        "Are you sure you want to remove yourself from this case?")) {
      return;
    }
    this.toRemove = new this.model(contributor);
    this.toRemove.api.remove().then(() => {
      if (this.user.id === contributor.id) {
        this.location.search('noRedirect', true);
        this.location.url('/home');
      } else {
        this.case.setProp(
          'contributors',
          this.case.data.contributors.filter(c => c.id !== contributor.id)
        )
      }
    });
  }
}

ContributorsCtrl.$inject = ['Contributor', 'CurrentCase', '$location',
  'CurrentUser', '$window', '$timeout', '$routeParams'
];

export default angular.module('controllers.contributors', [CaseModel,
    ContributorModel
  ])
  .controller('ContributorsCtrl', ContributorsCtrl)
  .name;



// WEBPACK FOOTER //
// ./project/modals/contributors/contributors.controller.js